import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import {useReduxAuth} from '../../../../app/modules/auth'

const Footer = () => {
  const {config} = useLayout()
  const {currentUser} = useReduxAuth()

  useEffect(() => {
    updateDOM(config)
  }, [config])

  const handleSupportClick = () => {
    const subject = `Portal Support Request from ${encodeURIComponent(currentUser?.name || '')}`
    window.location.href = `mailto:support@candihealth.com?subject=${subject}`
  }

  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        <p className='fs-6 py-2'>
          {new Date().getFullYear()} © CandiHealth {' '}
          <span className='text-primary cursor-pointer'
            title='Contact support via email'
            onClick={handleSupportClick}
          >
            Support
          </span>
        </p>
      </div>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
